(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-banner-tabs-v1"] && !Shopify.designMode) return;
  try {
    
  class YGBannerTabsV1 extends HTMLElement {
    constructor() {
      super();

      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleSlideChange = this.handleSlideChange.bind(this);
      this.handleDotToggle = this.handleDotToggle.bind(this);
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }

    connectedCallback() {
      if (this.isConnectedSetup) return;

      this.isConnectedSetup = true;

      this.addEventListener('yg:dot-toggle', this.handleDotToggle);

      this.autoplayConfig = {
        enabled: this.dataset.autoplayEnabled === 'true',
        interval: parseInt(this.dataset.autoplayInterval || '5', 10) * 1000
      };

      this.waitForSwiper();

      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      if (window.matchMedia('(hover: hover)').matches) {
        this.addEventListener('mouseenter', this.handleMouseEnter);
        this.addEventListener('mouseleave', this.handleMouseLeave);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('yg:dot-toggle', this.handleDotToggle);

      this.tabsContainer?.removeEventListener('click', this.handleTabClick);

      if (this.swiperInstance?.off) {
        this.swiperInstance.off('slideChange', this.handleSlideChange);
        this.swiperInstance.off('slideChangeTransitionEnd', this.handleSlideChange);
      }

      document.removeEventListener('visibilitychange', this.handleVisibilityChange);

      this.removeEventListener('mouseenter', this.handleMouseEnter);
      this.removeEventListener('mouseleave', this.handleMouseLeave);

      this.stopAutoplay();

      this.isConnectedSetup = false;
      this.isReady = false;
    }

    get swiperElement() {
      return this.querySelector('.yg-banner-swiper');
    }

    get swiperInstance() {
      return this.swiperElement?.swiper;
    }

    get tabsContainer() {
      return this.querySelector('.yg-tabs-title-container');
    }



    get tabs() {
      return Array.from(this.querySelectorAll('.yg-banner-tab-title'));
    }

    get slides() {
      return Array.from(this.querySelectorAll('.yg-banner-swiper .swiper-slide'));
    }

    waitForSwiper(attempt = 0) {
      if (this.isReady) return;

      if (this.swiperInstance) {
        this.initialize();
        return;
      }

      if (attempt > 40) return;

      requestAnimationFrame(() => this.waitForSwiper(attempt + 1));
    }

    initialize() {
      if (this.isReady) return;

      this.isReady = true;

      this.tabsContainer?.addEventListener('click', this.handleTabClick);

      this.swiperInstance?.on('slideChange', this.handleSlideChange);
      this.swiperInstance?.on('slideChangeTransitionEnd', this.handleSlideChange);

      const activeIndex = this.getActiveIndex();

      this.swiperInstance?.on('touchStart', () => {
        this.stopAutoplay();
      });

      this.swiperInstance?.on('touchEnd', () => {
        this.restartAutoplay();
      });

      this.syncActiveTab(activeIndex, {
        scrollBehavior: 'auto'
      });

      this.resetDots(activeIndex);

      if (this.autoplayConfig.enabled && this.slides.length > 1) {
        this.startAutoplay();
      }
    }

    getActiveIndex() {
      if (!this.swiperInstance) return 0;

      return typeof this.swiperInstance.realIndex === 'number'
        ? this.swiperInstance.realIndex
        : this.swiperInstance.activeIndex;
    }

    startAutoplay() {
      this.stopAutoplay();

      this.autoplayTimer = window.setTimeout(() => {
        this.goToNextSlide();
      }, this.autoplayConfig.interval);

      this.updatePaginationProgress();
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      this.clearPaginationProgress();
    }

    restartAutoplay() {
      if (!this.autoplayConfig.enabled) return;

      this.startAutoplay();
    }

    goToNextSlide() {
      if (!this.swiperInstance) return;

      const nextIndex =
        (this.getActiveIndex() + 1) % this.slides.length;

      this.swiperInstance.slideTo(nextIndex);
    }

    handleMouseEnter() {
      this.stopAutoplay();
    }

    handleMouseLeave() {
      this.restartAutoplay();
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.restartAutoplay();
      }
    }

    handleTabClick(event) {
      const tab = event.target.closest('.tab-title');

      if (!tab || !this.swiperInstance) return;

      const tabIndex = this.tabs.indexOf(tab);

      if (tabIndex < 0) return;

      this.swiperInstance.slideTo(tabIndex);

      this.syncActiveTab(tabIndex);

      this.resetDots(tabIndex);

      this.restartAutoplay();
    }

    handleSlideChange() {
      const activeIndex = this.getActiveIndex();

      this.syncActiveTab(activeIndex, {
        scrollBehavior: 'smooth'
      });

      this.resetDots(activeIndex);

      this.restartAutoplay();
    }

    handleDotToggle(event) {
      const { dot, isOpen } = event.detail || {};

      if (!dot || !isOpen) return;

      const currentSlide = dot.closest('.swiper-slide');

      if (!currentSlide) return;

      currentSlide.querySelectorAll('yg-dot-v1').forEach((item) => {
        if (item !== dot) {
          item.close(false);
        }
      });
    }

    syncActiveTab(index, options = {}) {
      if (!this.tabsContainer) return;

      const currentTab = this.tabs[index];

      if (!currentTab) return;

      const { scrollBehavior = 'smooth' } = options;

      if (typeof this.tabsContainer.toggleClass === 'function') {
        this.tabsContainer.toggleClass(currentTab, index);
      } else {
        this.tabs.forEach((tab) => {
          tab.classList.remove('is-active');
        });

        currentTab.classList.add('is-active');
      }

      this.scrollTabHorizontally(currentTab, scrollBehavior);
    }

    scrollTabHorizontally(tab, behavior = 'smooth') {
      const container = this.tabsContainer;

      if (!container || !tab) return;

      const containerRect = container.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();

      const targetScroll =
        container.scrollLeft +
        (tabRect.left - containerRect.left) -
        ((containerRect.width - tabRect.width) / 2);

      container.scrollTo({
        left: targetScroll,
        behavior
      });
    }

    updatePaginationProgress() {
      this.clearPaginationProgress();

      requestAnimationFrame(() => {
        const activeBullet = this.querySelector(
          '.swiper-pagination-bullet-active'
        );

        if (!activeBullet) return;

        activeBullet.style.setProperty(
          '--yg-autoplay-duration',
          `${this.autoplayConfig.interval}ms`
        );

        activeBullet.classList.remove('yg-autoplay-progress');

        void activeBullet.offsetWidth;

        requestAnimationFrame(() => {
          activeBullet.classList.add('yg-autoplay-progress');
        });
      });
    }

    clearPaginationProgress() {
      this.querySelectorAll('.swiper-pagination-bullet').forEach((item) => {
        item.classList.remove('yg-autoplay-progress');

        item.style.removeProperty('--yg-autoplay-duration');

        item.style.transition = 'none';

        void item.offsetWidth;

        item.style.removeProperty('transition');
      });
    }

    resetDots(activeIndex) {
      this.slides.forEach((slide, slideIndex) => {
        slide.querySelectorAll('yg-dot-v1').forEach((dot) => {
          if (slideIndex === activeIndex) {
            dot.reset();
          } else {
            dot.close(false);
          }
        });
      });
    }
  }

  if (!window.customElements.get('yg-banner-tabs-v1')) {
    window.customElements.define('yg-banner-tabs-v1', YGBannerTabsV1);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-with-icon"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  class YGSwiperCard extends YGUtils {
    constructor() {
      super();
      this.swiper = null;
      this.autoplayTimer = null;
      this.autoplayConfig = {
        enabled: false,
        interval: 5000
      };
    }

    connectedCallback() {
      if (this.swiper) return;

      this.autoplayConfig = {
        enabled: this.dataset.autoplayEnabled === 'true',
        interval: parseInt(this.dataset.autoplayInterval || '5', 10) * 1000
      };

      this.swiper = this.initSwiper(this);
      if (this.swiper && this.autoplayConfig.enabled && this.swiper.slides.length > 1) {
        this.startAutoplay();
      }

      this.swiper?.on('touchStart', () => this.stopAutoplay());
      this.swiper?.on('touchEnd', () => this.restartAutoplay());
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    startAutoplay() {
      this.stopAutoplay();
      this.updatePaginationProgress();
      this.autoplayTimer = window.setTimeout(() => {
        if (this.swiper) {
          this.swiper.slideNext();
          this.startAutoplay();
        }
      }, this.autoplayConfig.interval);
    }
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
      this.clearPaginationProgress();
    }
    restartAutoplay() {
      if (!this.autoplayConfig.enabled) return;
      this.startAutoplay();
    }
    updatePaginationProgress() {
      this.clearPaginationProgress();
      requestAnimationFrame(() => {
        const activeBullet = this.querySelector('.swiper-pagination-bullet-active');
        if (!activeBullet) return;
        activeBullet.style.setProperty(
          '--yg-autoplay-duration',
          `${this.autoplayConfig.interval}ms`
        );
        activeBullet.classList.remove('yg-autoplay-progress');
        void activeBullet.offsetWidth;
        requestAnimationFrame(() => {
          activeBullet.classList.add('yg-autoplay-progress');
        });
      });
    }
    clearPaginationProgress() {
      this.querySelectorAll('.swiper-pagination-bullet').forEach((item) => {
        item.classList.remove('yg-autoplay-progress');
        item.style.removeProperty('--yg-autoplay-duration');
        item.style.transition = 'none';
        void item.offsetWidth;
        item.style.removeProperty('transition');
      });
    }
  }

  if (!customElements.get('yg-swiper-card')) {
    customElements.define('yg-swiper-card', YGSwiperCard);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-marquee"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-packing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('.yg-packing-video-trigger');
  
  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const wrapper = trigger.closest('.yg-packing-button').querySelector('.yg-packing-video-wrapper');
      const videoElement = wrapper?.querySelector('yg-video');
      
      if (videoElement && videoElement.playVideo) {
        videoElement.playVideo();
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
